import type { ICommissionSummaryRequest } from './types';

interface ReportSelection {
    reportType: 'TRANSACTION' | 'DAILY_LOGIN';
    partnerId: string;
    userGroupName: string;
    fromDate: string;
    toDate: string;
    groupBy: string;
    secondaryFilters: string[];
}

export function buildReportRequest(
    selection: ReportSelection
): ICommissionSummaryRequest {
    const request: ICommissionSummaryRequest = {
        report_type: selection.reportType,
        partner_id: selection.partnerId,
        user_group_name: selection.userGroupName,
        from_date: selection.fromDate,
        to_date: selection.toDate,
    };
    if (selection.reportType === 'TRANSACTION') {
        request.group_by = selection.groupBy;
        request.sub_dealers =
            selection.groupBy === 'SUB_DEALER'
                ? selection.secondaryFilters
                : [];
        request.states =
            selection.groupBy === 'COUNTRY_STATE'
                ? selection.secondaryFilters
                : [];
    }
    return request;
}
